/**
 * ブライトコーブのメディアを操作するクラス
 * @class
 */
export default class Brightcove {
    /**
     * @param {string} videoJsIdName - 要素video-jsのid属性名
     * @param {function} cb - 再生後に行う処理
     */
    constructor(videoJsIdName, cb) {
        this.videoJsIdName = videoJsIdName;
        this.cb = cb;
        this.player = null;
        this.readyPlayer();
        this.registerEnded();
    }

    readyPlayer() {
        this.player = videojs(this.videoJsIdName);
        this.player.audioOnlyMode(true);
    }

    play() {
        this.player.play();
    }

    pause() {
        this.player.pause();
    }

    registerEnded() {
        this.player.on("ended", () => {
            this.cb();
        });
    }
}
